import React from "react";
import { AlertTriangle, Timer, Wind, Activity, ChevronRight, X } from "lucide-react";

const GOLD = "#c9a24b";

const OBJECTIVES = [
  { icon: Timer, title: "56-Minute Window", text: "The clock counts down from 56:00. When it reaches zero, the tower comes down." },
  { icon: Activity, title: "Manage Stamina", text: "Hazards \u2014 fire, live wires, debris \u2014 drain stamina. Reach zero and you fall." },
  { icon: Wind, title: "Pace Your Breath", text: "Descending burns breath; pause to recover. Smoke thickens as time runs out." },
];

export default function PreLaunchPanel({ open, povName, onConfirm, onCancel }) {
  if (!open) return null;
  return (
    <div
      data-testid="prelaunch-panel"
      style={{ position: "absolute", inset: 0, zIndex: 40, display: "flex", alignItems: "center", justifyContent: "center", padding: 24, background: "rgba(6,8,14,0.72)", backdropFilter: "blur(6px)", animation: "tab-fade 0.5s ease" }}
    >
      <div className="hud-panel" style={{ position: "relative", width: "min(560px, 92vw)", padding: "30px 30px 26px", borderRadius: 12, border: `1px solid ${GOLD}66` }}>
        <button data-testid="prelaunch-close" onClick={onCancel} style={{ position: "absolute", top: 14, right: 14, background: "transparent", border: "none", cursor: "pointer", color: "#7e8594" }}>
          <X size={18} />
        </button>

        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 4 }}>
          <AlertTriangle size={18} color="#e0533b" />
          <span className="crisis-tag" style={{ fontSize: 12, letterSpacing: "0.2em", textTransform: "uppercase" }}>Crisis Mode</span>
        </div>
        <h2 className="font-serif-q" style={{ margin: "0 0 6px", color: "#f4ecd6", fontSize: 26, fontWeight: 600 }}>Survival Objective</h2>
        <p style={{ color: "#c2c6cf", fontSize: 13.5, lineHeight: 1.55, margin: "0 0 20px" }}>
          You are entering as <strong style={{ color: GOLD }}>{povName}</strong>. Descend Stairwell A of the South Tower and reach the street before the 56-minute window closes.
        </p>

        <div style={{ display: "flex", flexDirection: "column", gap: 12, marginBottom: 24 }}>
          {OBJECTIVES.map((o, i) => (
            <div key={i} style={{ display: "flex", gap: 12, alignItems: "flex-start" }}>
              <div style={{ width: 32, height: 32, borderRadius: 8, border: `1px solid ${GOLD}55`, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, background: "rgba(201,162,75,0.08)" }}>
                <o.icon size={15} color={GOLD} />
              </div>
              <div>
                <div className="font-serif-q" style={{ color: "#f2e6c8", fontSize: 14.5, marginBottom: 2 }}>{o.title}</div>
                <div style={{ color: "#9aa0ac", fontSize: 12.5, lineHeight: 1.45 }}>{o.text}</div>
              </div>
            </div>
          ))}
        </div>

        <button
          data-testid="prelaunch-begin"
          onClick={onConfirm}
          className="gold-btn"
          style={{ width: "100%", padding: "14px", borderRadius: 5, cursor: "pointer", fontSize: 14, display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 9 }}
        >
          Begin the Descent <ChevronRight size={17} />
        </button>
      </div>
    </div>
  );
}
